import { createSlice } from '@reduxjs/toolkit';

type TraceInfoState = {
  preAlertData: any;
  preAlertPdfData: any;
  preAlertTotal: number;
  preAlertPdfTotal: any;
};

const initialState: TraceInfoState = {
  preAlertData: {},
  preAlertPdfData: {},
  preAlertPdfTotal: 0,
  preAlertTotal: 0,
};

export const traceInfoSlice = createSlice({
  name: 'traceInfo',
  initialState,
  reducers: {
    getPreAlert: (state, action) => {},
    getPreAlertSuccess: (state, action) => {
      state.preAlertData = action.payload.data;
      state.preAlertTotal = action.payload.total;
    },
    getPreAlertPdf: (state, action) => {},
    getPreAlertPdfSuccess: (state, action) => {
      state.preAlertPdfData = action.payload.data;
      state.preAlertPdfTotal = action.payload.total;
    },
    getPreAlertEncrypt: (state, action) => {},
    getPreAlertPdfEncrypt: (state, action) => {},
  },
});

export const {
  getPreAlert,
  getPreAlertPdf,
  getPreAlertPdfSuccess,
  getPreAlertSuccess,
  getPreAlertEncrypt,
  getPreAlertPdfEncrypt,
} = traceInfoSlice.actions;

export default traceInfoSlice.reducer;
